<template>
  <div class="container home-container">
    <router-view />
  </div>
</template>

<script>
export default {}
</script>
